"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import { COOKIE_CONSENT } from "@repo/constants";
import { type ConsentSettings, defaultConsentSettings } from "@repo/lib";
import { getCookie } from "cookies-next/client";
import { useEffect } from "react";

export function GTMConsent(): null {
  const consentCookieData = getCookie(COOKIE_CONSENT);

  const userConsentSettings = JSON.parse(
    consentCookieData ?? JSON.stringify(defaultConsentSettings),
  ) as ConsentSettings;

  useEffect(() => {
    sendGTMEvent({
      event: "consent",
      value: "default",
      gtm: userConsentSettings,
    });
  }, [userConsentSettings]);

  return null;
}
